import { createElementBlock as o, openBlock as t, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function c(p, e, a, d, i, f) {
  return t(), o("svg", s, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.437 2.25c1.549 0 2.813 1.225 2.813 2.75v16a.75.75 0 0 1-1.162.626l-6.082-4.002-6.094 4.003a.75.75 0 0 1-1.155-.524L4.75 21V5c0-1.525 1.264-2.75 2.813-2.75h8.874Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(n, [["render", c]]);
export {
  u as default
};
